import React, { useEffect, useState } from "react";
import {
  StyledButton,
  StyledInput,
  StyledSelect,
} from "../../components/styledComponent/styledElements";
import { Col, Divider, Form, Image, Row, Upload } from "antd";
import { CustomModal } from "../../components/styledComponent/styledModal";
import { AiOutlinePlus } from "react-icons/ai";
import { getProduct, updateProduct } from "../../server/productServices";
import { ShowNotification } from "../../components/notification/notification";
import { useAppContext } from "../../contexts/appContext";
import { listAllCategories } from "../../server/categoryServices";

const ProductCreationModal = ({
  showCreationModal = false,
  setShowCreationModal,
  onSubmit,
  formRef,
  update,
  setUpdate,
  setRefetch,
}) => {
  const { startLoading, stopLoading } = useAppContext();

  const { TextArea } = StyledInput;
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [removeImages, setRemoveImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const onSubmitForm = () => {
    formRef.current.submit();
  };
  const onCancelForm = () => {
    formRef.current.resetFields();
    setUpdate(null);
    setShowCreationModal(false);
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <div className="flex flex-col ">
        <AiOutlinePlus className="self-center" />
        <p className="mt-2">Upload</p>
      </div>
    </button>
  );
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const fetchProductDetails = async () => {
    startLoading();
    try {
      const res = await getProduct(update);
      formRef.current.setFieldsValue(res.data.product);
      setFileList(res.data.images);
      stopLoading();
    } catch (error) {
      stopLoading();
    }
  };
  const fetchCategories = async () => {
    try {
      const categories = await listAllCategories();
      var categoryOption = categories.data.map((val) => ({
        value: val.id,
        label: val.name,
      }));
      setCategories(categoryOption);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategories();
    if (update) {
      fetchProductDetails();
    }
  }, [update]);
  const handleUpdateProduct = (values, fileList) => {
    const files = fileList
      .filter((file) => file.originFileObj)
      .map((file) => file.originFileObj);
    startLoading();
    updateProduct(
      update,
      { ...values, image_to_be_deleted: removeImages },
      files
    )
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Product Updated Successfully",
        });
        setShowCreationModal(false);
        setRefetch(true);
      })
      .finally(() => {
        formRef.current.resetFields();
        stopLoading();
      });
  };
  return (
    <CustomModal
      title={update ? "Update Product" : "Add Product"}
      open={showCreationModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          {update ? "Update" : "Save"}
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />
      <Form
        ref={formRef}
        onFinish={
          update
            ? (val) => handleUpdateProduct(val, fileList)
            : (val) => onSubmit(val, fileList)
        }
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Product Name"
              name="name"
              rules={[
                { required: true, message: "Please enter product name!" },
              ]}
            >
              <StyledInput width={"100%"} placeholder="Enter Product Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Product Name Arabic" name="name_arabic">
              <StyledInput
                width={"100%"}
                placeholder="Enter Product Name in arabic"
                dir="rtl"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Product Code"
              name="code"
              rules={[
                { required: true, message: "Please enter product Code!" },
              ]}
            >
              <StyledInput width={"100%"} placeholder="Enter Product Code" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Brand" name="brand">
              <StyledInput width={"100%"} placeholder="Enter Product Brand" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Brand Arabic" name="brand_arabic">
              <StyledInput
                width={"100%"}
                placeholder="Enter Product Brand in arabic"
                dir="rtl"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Quantity"
              name="box_quantity"
              getValueFromEvent={(e) => parseFloat(e.target.value) || 0}
            >
              <StyledInput type="number" width={"100%"} placeholder="12" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Category Id" name="category_id">
              <StyledSelect
                type="number"
                width={"100%"}
                placeholder="Select Category"
                options={categories}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Discount %"
              name="offer"
              getValueFromEvent={(e) => parseFloat(e.target.value) || 0}
              rules={[
                {
                  type: "number",
                  min: 0,
                  max: 100,
                  message: "Discount must be between 0 and 100",
                },
              ]}
            >
              <StyledInput
                type="number"
                width={"100%"}
                min={0}
                max={100}
                placeholder="Enter product discount"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Purchase Rate"
              name="purchase_rate"
              getValueFromEvent={(e) => parseFloat(e.target.value) || 0}
              rules={[
                {
                  required: true,
                  message: "Please enter product purchase rate!",
                },
              ]}
            >
              <StyledInput type="number" width={"100%"} placeholder="280" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="MRP"
              name="mrp"
              getValueFromEvent={(e) => parseFloat(e.target.value) || 0}
              rules={[{ required: true, message: "Please enter product MRP!" }]}
            >
              <StyledInput
                type="number"
                width={"100%"}
                placeholder="Enter MRP"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="VIP MRP"
              name="vip_mrp"
              getValueFromEvent={(e) => parseFloat(e.target.value) || 0}
            >
              <StyledInput
                type="number"
                width={"100%"}
                placeholder="Enter special MRP"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Details" name="details">
              <StyledInput width={"100%"} placeholder="Enter Details" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Details Arabic" name="details_arabic">
              <StyledInput
                width={"100%"}
                placeholder="Enter Details in arabic"
                dir="rtl"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Description (Use | to seperate) "
              name="description"
            >
              <TextArea
                width={"100%"}
                placeholder="Enter Description"
                showCount
                autoSize={{
                  minRows: 2,
                  maxRows: 6,
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Description in arabic" name="description_arabic">
              <TextArea
                width={"100%"}
                placeholder="Enter Description in arabic"
                showCount
                autoSize={{
                  minRows: 2,
                  maxRows: 6,
                }}
                dir="rtl"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Upload Images" name="files">
              <Upload
                listType="picture-card"
                beforeUpload={() => false}
                multiple={true}
                fileList={fileList}
                onChange={handleUploadChange}
                onPreview={handlePreview}
                accept=".png,.jpg,.jpeg"
                onRemove={(val) => {
                  update && setRemoveImages([...removeImages, val.id]);
                }}
              >
                {fileList.length >= 8 ? null : uploadButton}
              </Upload>
              {previewImage && (
                <Image
                  wrapperStyle={{
                    display: "none",
                  }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) =>
                      !visible && setPreviewImage(""),
                  }}
                  src={previewImage}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};

export default ProductCreationModal;
